import React, { useState } from 'react';
import WalletCard from './WalletCard';

// Falls back to the salon initial when there's no logo OR the logo URL fails
// to load (broken/relative/404), so we never show the browser's broken-image
// glyph.
const SalonAvatar = ({ name, logo }) => {
  const [failed, setFailed] = useState(false);
  return logo && !failed ? (
    <img className="wallet-salon-logo" src={logo} alt="" onError={() => setFailed(true)} />
  ) : (
    <span className="wallet-salon-logo wallet-salon-logo-fallback">
      {(name || '?').charAt(0).toUpperCase()}
    </span>
  );
};

// WalletSalonGroup — one salon's assets: a salon header + its cards. Loyalty
// schemes for the same salon will render inside this group too (next phase).
const WalletSalonGroup = ({ group, onCardClick }) => (
  <section className="wallet-group">
    <header className="wallet-group-header">
      <SalonAvatar name={group.salon.name} logo={group.salon.logo} />
      <h2 className="wallet-group-name">{group.salon.name}</h2>
      <span className="wallet-group-count">
        {group.items.length} card{group.items.length === 1 ? '' : 's'}
      </span>
    </header>
    <div className="wallet-group-cards">
      {group.items.map((item) => (
        <WalletCard key={item.id} item={item} onClick={onCardClick} />
      ))}
    </div>
  </section>
);

export default WalletSalonGroup;
